import logoUrl from "../../public/images/logo-full-dark-white.svg";

export function Landing() {
  return (
    <div className="relative flex min-h-screen w-full flex-col items-center justify-center gap-8 bg-background px-6 text-center">
      <img src={logoUrl} alt="Tendra" className="h-32 w-auto" />
      <div className="flex max-w-lg flex-col gap-3">
        <h1 className="text-2xl font-semibold text-foreground">Coming soon.</h1>
        <p className="text-sm text-foreground/70">
          Tendra is a Zero Trust Infrastructure Access Platform.
        </p>
      </div>
    </div>
  );
}
